<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <div class="row">
            <h3 class="col-6">{{ $t("BUTTONS.working_hours") }}</h3>
            <div class="col-6 text-end">
              <v-btn @click="$router.go(-1)" style="color: #405950">
                <i
                  :class="
                    $i18n.locale === 'en' ? 'fas fa-forward' : 'fas fa-backward'
                  "
                ></i>
              </v-btn>
            </div>
          </div>
          <!-- <div v-if="data.work_hours.length == 0" class="text-center">
            <h5 class="my-5 mx-2 d-inline">{{ $t("TABLES.noData") }}</h5>
            <button type="button" @click="addWorkDay">
              <i
                class="fas fa-plus-circle"
                style="font-size: 20px; color: #007bff"
              ></i>
            </button>
          </div> -->
          <div v-for="(element, index) in data.work_hours" :key="index">
            <base-select-input
              col="10"
              :optionsList="filteredDays"
              :placeholder="$t('PLACEHOLDERS.day')"
              v-model="element.day_id"
              disabled
            />
            <div
              v-if="element.times?.length > 0"
              v-for="(time, timeIndex) in element.times"
              :key="timeIndex"
              class="row"
            >
              <base-input
                v-if="time.start_time_format && time.start_time_format.includes('am' || 'pm')"
                col="4"
                type="time"
                :placeholder="$t('TABLES.ImagesSpaces.start_time')"
                v-model.trim="time.start_time_format"
                disabled
                @input="setAllDays"
              />

              <base-input
                v-else
                col="4"
                type="time"
                :placeholder="$t('TABLES.ImagesSpaces.start_time')"
                v-model.trim="time.start_time_format"
                @input="setAllDays"
              />
              <base-input
                v-if="time.end_time_format && time.start_time_format.includes('am' || 'pm')"
                col="4"
                type="time"
                :placeholder="$t('TABLES.ImagesSpaces.end_time')"
                v-model.trim="time.end_time_format"
                disabled
                @input="setAllDays"
              />
              <base-input
                col="4"
                type="time"
                :placeholder="$t('TABLES.ImagesSpaces.end_time')"
                v-model.trim="time.end_time_format"
                @input="setAllDays"
              />
              <div class="col-3 mt-5 pt-5">
                <button
                  type="button"
                  v-if="
                    time.end_time_format != null ||
                    time.start_time_format != null ||
                    timeIndex > 0
                  "
                  @click="
                    removeWorkDay(index, timeIndex, time.id, element.day_id)
                  "
                >
                  <i
                    class="fas fa-minus-circle"
                    style="font-size: 20px; color: #007bff; margin-left: 5px"
                  ></i>
                </button>
                <button
                  type="button"
                  @click="addWorkDay(element.day_id.id)"
                  v-if="timeIndex === element.times.length - 1"
                >
                  <i
                    class="fas fa-plus-circle"
                    style="font-size: 20px; color: #007bff"
                  ></i>
                </button>
              </div>
            </div>
            <div v-if="element.times?.length == 0">
              <button type="button" @click="addWorkDay(element.day_id.id)">
                <i
                  class="fas fa-plus-circle"
                  style="font-size: 20px; color: #007bff"
                ></i>
                {{ $t("BUTTONS.addTime") }}
              </button>
            </div>
            <hr class="my-5 py-5" />
          </div>

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
              v-if="data.work_hours.length != 0"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- End:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "GeneralSettings",

  data() {
    return {
      isWaitingRequest: false,
      data: {
        oldWorkHours: [],
        work_hours: [
          {
            day_id: { id: null, name: null },
            times: [
              {
                id: null,
                start_time_format: null,
                end_time_format: null,
              },
            ],
          },
        ],
      },
      dayMappingToEnglish: {
        الأحد: "Sunday",
        الاثنين: "Monday",
        الثلاثاء: "Tuesday",
        الأربعاء: "Wednesday",
        الخميس: "Thursday",
        الجمعة: "Friday",
        السبت: "Saturday",
      },
    };
  },

  computed: {
    dayMapping() {
      return {
        السبت: { id: 1, name: this.$t("days.Saturday"), name_en : 'saturday' },
        الأحد: { id: 2, name: this.$t("days.Sunday"), name_en : 'sunday' },
        الاثنين: { id: 3, name: this.$t("days.Monday"), name_en : 'monday' },
        الثلاثاء: { id: 4, name: this.$t("days.Tuesday"), name_en : 'tuesday' },
        الأربعاء: { id: 5, name: this.$t("days.Wednesday"), name_en : 'wednesday' },
        الخميس: { id: 6, name: this.$t("days.Thursday"), name_en : 'thursday' },
        الجمعة: { id: 7, name: this.$t("days.Friday"), name_en : 'friday' },
      };
    },
    filteredDays() {
      const usedDays = new Set(
        this.data.work_hours.map((workHour) => workHour.day_id?.id)
      );
      const usedDaysNames = new Set(
        this.data.work_hours.map((workHour) => workHour.day_id?.name)
      );
      return Object.values(this.dayMapping).filter(
        (day) => !usedDaysNames.has(day.name)
      );
    },
  },
  methods: {
    setAllDays() {
      if (this.data.oldWorkHours.length) return;

      const sourceDay = this.data.work_hours.find((workHour) =>
        workHour.times.some(
          (time) => time.start_time_format || time.end_time_format
        )
      );

      if (!sourceDay) return;

      this.data.work_hours = this.data.work_hours.map((workHour) => ({
        day_id: workHour.day_id,
        times: sourceDay.times.map((time) => ({
          id: time.id ?? null,
          start_time_format: time.start_time_format ?? null,
          end_time_format: time.end_time_format ?? null,
        })),
      }));
    },
    addWorkDay(dayId) {
      const currentDay = this.data.work_hours.find(
        (workHour) => workHour.day_id.id === dayId
      );

      if (currentDay) {
        currentDay.times.push({
          id: null,
          start_time_format: null,
          end_time_format: null,
        });
      } else {
        // If no such day exists (shouldn't happen in your case), you can add a new entry
        this.data.work_hours.push({
          day_id: { id: dayId, name: this.dayMapping[dayId].name },
          times: [
            {
              id: null,
              start_time_format: null,
              end_time_format: null,
            },
          ],
        });
      }
    },

    async removeWorkDay(index, item_index, time_id, day_id) {
      try {
        // If time_id exists, call the API to delete the time entry
        if (time_id) {
          this.isWaitingRequest = true;
          await this.$axios({
            method: "DELETE",
            url: `schedule-store/delete/${time_id}`,
          });
          this.isWaitingRequest = false;
          this.$message.success(this.$t("MESSAGES.deletedSuccessfully"));
          this.getDataToEdit();
        } else {
          this.data.work_hours[index].times.splice(item_index, 1);

          if (this.data.work_hours[index].times.length === 0) {
            this.data.work_hours[index].times.push({
              id: null,
              start_time_format: null,
              end_time_format: null,
            });
          }

          this.$message.success(this.$t("MESSAGES.deletedSuccessfully"));
        }
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.errors.message[0]);
      }
    },

    async getDataToEdit() {
      try {
        let res = await this.$axios.get(
          `providers/${this.$route.params.id}`
        );
        this.data.oldWorkHours =
          res.data.data.Provider.working_time_slots || [];

        this.data.work_hours = (
          res.data.data.Provider.working_time_slots || []
        ).map((schedule) => {
          const dayMappingItem = Object.values(this.dayMapping).find(
            (day) => {
              return day.name_en === schedule.day;
            }
          );

          if (dayMappingItem) {
            return {
              day_id: { id: dayMappingItem.id, name: dayMappingItem.name,name_en: dayMappingItem.name_en },
              times: schedule.times.map((time) => ({
                start_time_format: time.from,
                end_time_format: time.to,
              })),
            };
          } else {
            return null;
          }
        }).filter((item) => item !== null);

        const existingDayIds = new Array(
          this.data.work_hours.map((workHour) => workHour.day_id.id)
        )[0];

        const allDayIds = Object.values(this.dayMapping).map((day) => day.id);
        allDayIds.forEach((dayId) => {
          if (!existingDayIds.includes(dayId)) {
            // Add missing day with empty times
            this.data.work_hours.push({
              day_id: {
                id: dayId,
                name: Object.values(this.dayMapping).find(
                  (day) => day.id == dayId
                ).name,
                name_en: Object.values(this.dayMapping).find(
                  (day) => day.id == dayId
                ).name_en,
              },
              times: [{ id: null, start_time_format: null, end_time_format: null }],
            });
          }
          console.log(this.data.work_hours)
        });
      } catch (error) {
        console.error("Error fetching work hours data:", error);
      }
    },

    validateFormInputs() {
      this.submitForm();
    },

    async submitForm() {
      this.isWaitingRequest = true;
      console.log(this.data.work_hours);

      // Construct REQUEST_DATA with at least the day and times array, even if times are empty or invalid
      const REQUEST_DATA = {
        working_time_slots: this.data.work_hours
          .map((workHour) => {
            const validTimes = workHour.times.filter(
              (time) => time.start_time_format && time.end_time_format
            );

            // if (validTimes.length > 0) {
            console.log(workHour)
              return {
                day: workHour.day_id.name_en,
                times: validTimes.map((time) => ({
                  from: time.start_time_format,
                  to: time.end_time_format,
                })),
              };
            // }
            return null;
          })
          .filter((item) => item !== null),
      };
      REQUEST_DATA._method = 'PUT';


      console.log("REQUEST_DATA", REQUEST_DATA);


      try {
        await this.$axios({
          method: "POST",
          url: `providers/${this.$route.params.id}/working-time-slots`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.savedSuccessfully"));
        this.getDataToEdit();
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.errors.message[0]);
      }
    },
    async getDays() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "days",
        });
        this.days = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
  },

  created() {
    this.getDays();
    this.getDataToEdit();
  },
};
</script>

<style scoped>
.item-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.disabled_button {
  color: #a0a0a0 !important;
  cursor: not-allowed !important;
  pointer-events: all !important;
}
</style>
